import {
    GET_CUSTOMER_INSURANCE_REQUEST,
    GET_CUSTOMER_INSURANCE_SUCCESS,
    GET_CUSTOMER_INSURANCE_FAILURE,
    POST_CUSTOMER_INSURANCE_REQUEST,
    POST_CUSTOMER_INSURANCE_SUCCESS,
    POST_CUSTOMER_INSURANCE_FAILURE ,
    ADD_PREVIEW_CUSTOMER_INSURANCE ,
    REMOVE_PREVIEW_CUSTOMER_INSURANCE,
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: [],
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMER_INSURANCE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_CUSTOMER_INSURANCE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.insuranceDetails,
                isInitialFetch: false,
            };
        case GET_CUSTOMER_INSURANCE_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case ADD_PREVIEW_CUSTOMER_INSURANCE: {
            const newInsuranceDetails = action.payload.insuranceDetails.map((d) => ({...d, isDisabled: true}));
            return {
                ...state,
                data: [...newInsuranceDetails, ...state.data],
            };
        }
        case REMOVE_PREVIEW_CUSTOMER_INSURANCE: {
            return {
                ...state,
                data: state.data.filter((f) => !f.isDisabled),
            };
        }
            case POST_CUSTOMER_INSURANCE_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    data: action.payload.insuranceDetails,
                    isInitialFetch: false,
                };
        default:
            return state;
    }
};